import axios from 'axios';
import { downloadExcel, downloadFile } from '../utils/files';
import { INewMeasure, INewMeasureAction } from '../utils/interfaces/interfaces';
import { measures_actionsApi, principal_measuresAPI } from './routes';

const getMeasure = async (id: number) =>
  await axios.get(principal_measuresAPI.BY_ID(id));

const getMeasuresDecision = async (id: number) =>
  await axios.get(principal_measuresAPI.ALL(id));

const addMeasure = async (measure: INewMeasure) =>
  await axios.post(principal_measuresAPI.ADD, { ...measure });

const deleteMeasure = (id: number) =>
  axios.delete(principal_measuresAPI.DELETE(id));

const editObservations = async (idMeasure: number, observations: string) =>
  await axios.put(principal_measuresAPI.EDIT_OBSERVATIONS, {
    id: idMeasure,
    observations
  });

const addActionStatus = async (form: INewMeasureAction) => {
  const data = new FormData();

  data.append('Status', form.status!.toString());
  data.append('DecisionMeasureId', form.decisionMeasureId.toString());
  data.append('DecisionDocument', form.decisionDocument!);
  data.append(
    'DecisionMeasureActionDescription',
    form.decisionMeasureActionDescription
  );
  data.append('DecisionDocumentName', form.decisionDocumentName!);
  data.append('DecisionDocumentDescription', form.decisionDocumentDescription!);
  return await axios.post(measures_actionsApi.ACTION_STATUS, data);
};

const addActionDeadline = async (form: INewMeasureAction) => {
  const data = new FormData();

  data.append('ProlongedDeadline', form.prolongedDeadline!.toString());
  data.append('DecisionMeasureId', form.decisionMeasureId.toString());
  data.append('DecisionDocument', form.decisionDocument!);
  data.append(
    'DecisionMeasureActionDescription',
    form.decisionMeasureActionDescription
  );
  data.append('DecisionDocumentName', form.decisionDocumentName!);
  data.append('DecisionDocumentDescription', form.decisionDocumentDescription!);
  return await axios.post(measures_actionsApi.ACTION_DEADLINE, data);
};

const addActionStatusWithDoc = async (form: INewMeasureAction) => {
  const data = new FormData();

  data.append('Status', form.status!.toString());
  data.append('DecisionMeasureId', form.decisionMeasureId.toString());
  data.append(
    'DecisionMeasureActionDescription',
    form.decisionMeasureActionDescription
  );
  data.append('DecisionDocumentId', form.decisionDocumentId!.toString());

  return await axios.post(measures_actionsApi.ACTION_DOC_STATUS, data);
};

const addActionDeadlineWithDoc = async (form: INewMeasureAction) => {
  const data = new FormData();

  data.append('ProlongedDeadline', form.prolongedDeadline!.toString());
  data.append('DecisionMeasureId', form.decisionMeasureId.toString());
  data.append(
    'DecisionMeasureActionDescription',
    form.decisionMeasureActionDescription
  );
  data.append('DecisionDocumentId', form.decisionDocumentId!.toString());

  return await axios.post(measures_actionsApi.ACTION_DOC_DEADLINE, data);
};

const downloadRaportPerMeasure = async (
  measureId: number,
  name: string,
  title: string
) => {
  await axios
    .get(principal_measuresAPI.DOWNLOAD_RAPORT_MEASURE(measureId, title), {
      responseType: 'blob'
    })
    .then(({ data }) => {
      downloadExcel(data, `Raport - ${name}`);
    });
};

const downloadActionDocument = async (actionId: number, name: string) => {
  await axios
    .get(measures_actionsApi.ACTION_DOC_DOWNLOAD(actionId), {
      responseType: 'blob'
    })
    .then(({ data }) => {
      downloadFile(data, `${name}`);
    });
};

/* monitorization documents */
const getMeasureDocuments = async (id: number) =>
  await axios.get(measures_actionsApi.MEASURE_DOCS(id));
export {
  getMeasure,
  deleteMeasure,
  addMeasure,
  getMeasuresDecision,
  editObservations,
  addActionStatus,
  addActionDeadline,
  downloadRaportPerMeasure,
  addActionStatusWithDoc,
  addActionDeadlineWithDoc,
  downloadActionDocument,
  getMeasureDocuments
};
